import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const ImagePreviewModal = ({ imageUrl, isOpen, onClose, title }) => {
  if (!isOpen || !imageUrl) return null;
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] p-2">
        <DialogHeader className="p-2">
          <DialogTitle className="text-lg">{title || "Vista previa"}</DialogTitle>
        </DialogHeader>
        <div className="flex items-center justify-center bg-slate-50 rounded-sm p-4 min-h-[400px]">
          <img 
            src={imageUrl} 
            alt={title || "Preview"} 
            className="max-w-full max-h-[70vh] object-contain"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewModal;
